import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { DeleteFolderResponse } from "../../proto/api_pb";
import { TrackFile } from "../../proto/api_pb";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { deleteFolder } from "../../services/folderService";
import FolderIcon from "@mui/icons-material/Folder";
import { FoldersSectionProps } from "./types";
import { postTrackFile } from "../../services/trackService";
import { RpcError } from "grpc-web";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { styles } from "./styles";

export const FoldersSection: React.FC<FoldersSectionProps> = ({
  draggedIndex,
  selectedFiles,
  files,
  getAllFoldersList,
  foldersList,
  handleFetchTrackFiles,
}) => {
  const { getValidAccessToken } = useGetValidAccessToken();
  const navigate = useNavigate();

  const handleDrop = async (folderIndex: any) => {
    if (draggedIndex !== null) {
      const updatedFiles = [...selectedFiles];
      const draggedItem = updatedFiles[draggedIndex];
      const trackFile = new TrackFile();
      trackFile.setId(draggedItem.trackFile.getId());
      trackFile.setTrackId(draggedItem.trackFile.getTrackId());
      trackFile.setFileUrl(draggedItem.trackFile.getFileUrl());
      trackFile.setFilename(draggedItem.trackFile.getFilename());
      trackFile.setLabel(draggedItem.trackFile.getLabel());
      trackFile.setOwnerId(draggedItem.trackFile.getOwnerId());
      trackFile.setType(draggedItem.trackFile.getType());
      trackFile.setFileState(draggedItem.trackFile.getFileState());
      trackFile.setTrackIdsList(draggedItem.trackFile.getTrackIdsList());
      trackFile.setCollaboratorsList(
        draggedItem.trackFile.getCollaboratorsList()
      );
      trackFile.setFolderId(foldersList[folderIndex].getId());
      const postTrackFileResponse = await postTrackFile(
        trackFile,
        await getValidAccessToken()
      );
      if (postTrackFileResponse instanceof RpcError) {
        toast.error("Fail to add file in folder");
      } else {
        handleFetchTrackFiles();
        toast.info("File added in folder successfully");
      }
    }
  };
  useEffect(() => {
    getAllFoldersList();
  }, [getAllFoldersList]);

  const handleDeleteFolder = async (id: string) => {
    const token = await getValidAccessToken();
    const response = await deleteFolder(token, id);
    if (response instanceof RpcError) {
      toast.error("Fail to delete folder");
    } else if (response instanceof DeleteFolderResponse) {
      toast.error("Successfully deleted folder");
    }
  };

  return (
    <>
      {foldersList.length > 0 && (
        <Box>
          <Typography sx={{ marginLeft: "10px" }} variant="h4">
            {foldersList.length === 1 ? "Folder" : "Folders"}
          </Typography>
          <Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
              {foldersList.map((folder, i) => {
                return (
                  <Box key={i}>
                    <Box
                      sx={{ textAlign: "center" }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={() => handleDrop(i)}
                    >
                      <FolderIcon
                        onClick={() =>
                          navigate(`/folder/${folder.getId()}`, {
                            state: { name: folder.getName() },
                          })
                        }
                        sx={{ fontSize: "150px", cursor: "pointer" }}
                      />
                      <Box sx={styles.folderDetailsContainer}>
                        <Typography sx={styles.folderName}>
                          {folder.getName()}
                        </Typography>
                        <Box
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <DeleteIcon
                            onClick={() => handleDeleteFolder(folder.getId())}
                            sx={{ fontSize: "22px", cursor: "pointer" }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>

          <hr />
        </Box>
      )}
      {files?.length === 0 && foldersList.length === 0 && (
        <Box>
          <Typography sx={{ textAlign: "center" }} variant="h6">
            This folder is empty!
          </Typography>
        </Box>
      )}
    </>
  );
};
